import { useEffect } from 'react';
// https://newbedev.com/prevent-safari-loading-from-cache-when-back-button-is-clicked
export const usePageShow = (onPageShow) => {
    useEffect(() => {
        const handler = (e) => {
            if (e.persisted) {
                onPageShow ? onPageShow() : window.location.reload();
            }
        };
        window.addEventListener('pageshow', handler);
        return () => {
            window.removeEventListener('pageshow', handler);
        };
    }, []);
};
